import { render } from "./DriverList.vue?vue&type=template&id=2cb7ff71&scoped=true"
import script from "./DriverList.vue?vue&type=script&lang=js"
export * from "./DriverList.vue?vue&type=script&lang=js"

import "./DriverList.vue?vue&type=style&index=0&id=2cb7ff71&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2cb7ff71"

export default script